<div *ngFor="let fieldItem of fields | filterBy: filter; let fieldIndex = index"
  [ngClass]="(fieldItem.isgroup ? 'right-group-row' : 'right-item-row')">
  <ng-container *ngIf="!selectedTab || (selectedTab && fieldItem.tab && fieldItem.tab === selectedTab)">
    <field-item-group *ngIf="fieldItem.isgroup && (fieldItem.items && fieldItem.items.length)" [isRoot]="true"
      [type]="type" [isLtr]="isLtr" [dragSrc]="dragSrc" [hidden]="!visible" [hideFields]="hideFields"
      [fieldItem]="fieldItem" [parentFieldItem]="null" [lines]="lines" [fieldIndex]="fieldIndex"
      [rightPrefix]="rightPrefix" [filter]="filter" (showHideField)="showHideField($event)"
      (deleteSelection)="deleteSelection($event)" (handleEndPointSelection)="handleEndPointSelection($event)"
      (handleStartPointSelection)="handleStartPointSelection($event)"
      (addDataTransformation)="onAddDataTransformation($event)" (toggleBlock)="toggleBlock($event)"
      (changeGroupMetaAfterNgOnChange)="changeGroupMetaAfterNgOnChange($event)"
      (changeGroupMetaAfterLineChange)="changeGroupMetaAfterLineChange($event)"
      (toggleGroupVisibility)="toggleGroupVisibility($event)" style="--i: {{fieldItem.level ? fieldItem.level : 1}}">
    </field-item-group>
    <field-item *ngIf="!fieldItem.isgroup" [id]="fieldItem.meta && fieldItem.meta.id" [type]="type" [isRoot]="true"
      [isLtr]="isLtr" [dragSrc]="dragSrc" [hidden]="hideFields[fieldItem.field.name] && !visible"
      [hideFields]="hideFields" [fieldItem]="fieldItem" [lines]="lines" [rightPrefix]="rightPrefix"
      (showHideField)="showHideField($event)" (deleteSelection)="deleteSelection($event)"
      (handleEndPointSelection)="handleEndPointSelection($event)"
      (handleStartPointSelection)="handleStartPointSelection($event)"
      style="--i: {{fieldItem.level ? fieldItem.level : 1}}" (addDataTransformation)="onAddDataTransformation($event)">
    </field-item>
  </ng-container>
</div>